export function isHtmlString(inputString: string) {
  const htmlPattern = /<[^>]*>/;

  return htmlPattern.test(inputString);
}
